"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FrameRange = _interopRequireDefault(require("../interval/FrameRange"));

var _WireObject2 = _interopRequireDefault(require("../WireObject"));

var _creative = require("../../constants/creative");

var _convertMapToObject = _interopRequireDefault(require("../../utils/object/convertMapToObject"));

var _convertObjectToMap = _interopRequireDefault(require("../../utils/object/convertObjectToMap"));

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _removeUnusedKeys = _interopRequireDefault(require("../../utils/object/removeUnusedKeys"));

var _toJSON2 = _interopRequireDefault(require("../../utils/object/toJSON"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _CreativeDocumentContent = _interopRequireDefault(require("./CreativeDocumentContent"));

var _CreativeDocumentElement = _interopRequireDefault(require("./CreativeDocumentElement"));

var _CreativeDocumentMask = _interopRequireDefault(require("./CreativeDocumentMask"));

var _CreativeDocumentMedium = _interopRequireDefault(require("./CreativeDocumentMedium"));

var _CreativeDocumentMetadata = _interopRequireDefault(require("./CreativeDocumentMetadata"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CreativeDocumentModel = /*#__PURE__*/function (_WireObject) {
  (0, _inherits2["default"])(CreativeDocumentModel, _WireObject);

  var _super = _createSuper(CreativeDocumentModel);

  function CreativeDocumentModel() {
    var _this;

    (0, _classCallCheck2["default"])(this, CreativeDocumentModel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_content", new Map());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_creativeMode", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_elements", new Map());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_frameRate", _creative.PLAYBACK_FRAMES_PER_SECOND);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_masks", new Map());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_media", new Map());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_metadata", new _CreativeDocumentMetadata["default"]());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rootElementIds", new Set());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_version", _creative.CURRENT_CREATIVE_FORMAT_VERSION);
    return _this;
  }

  (0, _createClass2["default"])(CreativeDocumentModel, [{
    key: "copy",
    value: function copy() {
      var json = this.toJSON();
      return CreativeDocumentModel.fromJSON(json);
    }
    /**
     * PLEASE NOTE: These JSON function convert fields like "content" to
     * "contentById". "content" in the JSON is then drived from the keys
     * in the map.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var contentById = (0, _convertMapToObject["default"])(this.content, _toJSON2["default"]);
      var content = Object.keys(contentById);
      var elements = Array.from(this.rootElementIds);
      var elementsById = (0, _convertMapToObject["default"])(this.elements, _toJSON2["default"]);
      var masks = (0, _convertMapToObject["default"])(this.masks, _toJSON2["default"]);
      var mediaById = (0, _convertMapToObject["default"])(this.media, _toJSON2["default"]);
      var media = Object.keys(mediaById);
      var creativeMode = this.creativeMode;
      var modelObj = {
        content: {
          content: content,
          contentById: contentById
        },
        creativeMode: creativeMode,
        elements: {
          elements: elements,
          elementsById: elementsById,
          masks: masks
        },
        frameRate: this.frameRate,
        media: {
          media: media,
          mediaById: mediaById
        },
        metadata: this.metadata.toJSON(),
        version: this.version
      };
      return (0, _removeUnusedKeys["default"])(modelObj);
    }
  }, {
    key: "content",
    get: function get() {
      return this._content;
    },
    set: function set(content) {
      this._content = content;
    }
  }, {
    key: "creativeMode",
    get: function get() {
      return this._creativeMode;
    },
    set: function set(creativeMode) {
      this._creativeMode = creativeMode;
    }
  }, {
    key: "elements",
    get: function get() {
      return this._elements;
    },
    set: function set(elements) {
      this._elements = elements;
    }
  }, {
    key: "frameRate",
    get: function get() {
      return this._frameRate;
    },
    set: function set(frameRate) {
      this._frameRate = frameRate;
    }
  }, {
    key: "masks",
    get: function get() {
      return this._masks;
    },
    set: function set(masks) {
      this._masks = masks;
    }
  }, {
    key: "media",
    get: function get() {
      return this._media;
    },
    set: function set(media) {
      this._media = media;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this._metadata;
    },
    set: function set(metadata) {
      this._metadata = metadata;
    }
  }, {
    key: "rootElementIds",
    get: function get() {
      return this._rootElementIds;
    },
    set: function set(rootElementIds) {
      this._rootElementIds = rootElementIds;
    }
  }, {
    key: "version",
    get: function get() {
      return this._version;
    },
    set: function set(version) {
      this._version = version;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inModel) {
      var content = inModel.content,
          creativeMode = inModel.creativeMode,
          elements = inModel.elements,
          media = inModel.media,
          metadata = inModel.metadata,
          frameRate = inModel.frameRate,
          version = inModel.version;
      var creativeDocumentModel = new CreativeDocumentModel();

      if ((0, _isNotNil["default"])(content)) {
        var contentById = content.contentById;
        creativeDocumentModel.content = (0, _convertObjectToMap["default"])(contentById, _CreativeDocumentContent["default"].fromJSON);
      }

      if ((0, _isNotNil["default"])(elements)) {
        var elementsById = elements.elementsById,
            rootElementIds = elements.elements,
            masks = elements.masks;
        creativeDocumentModel.elements = (0, _convertObjectToMap["default"])(elementsById, _CreativeDocumentElement["default"].fromJSON);
        creativeDocumentModel.rootElementIds = new Set(rootElementIds);
        creativeDocumentModel.masks = (0, _convertObjectToMap["default"])(masks, _CreativeDocumentMask["default"].fromJSON);
      }

      if ((0, _isNotNil["default"])(media)) {
        var mediaById = media.mediaById;
        creativeDocumentModel.media = (0, _convertObjectToMap["default"])(mediaById, _CreativeDocumentMedium["default"].fromJSON);
      }

      if ((0, _isNotNil["default"])(metadata)) {
        creativeDocumentModel.metadata = _CreativeDocumentMetadata["default"].fromJSON(metadata);
      }

      if ((0, _isNumber["default"])(frameRate)) {
        creativeDocumentModel.frameRate = frameRate;
      }

      if ((0, _isNumber["default"])(version)) {
        creativeDocumentModel.version = version;
      }

      if (_creative.VALID_CREATIVE_MODES.has(creativeMode)) {
        creativeDocumentModel.creativeMode = creativeMode;
      }

      return creativeDocumentModel;
    }
    /**
     * Checks if object is an instance of CreativeDocumentModel
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isCreativeDocumentModel",
    value: function isCreativeDocumentModel(inputObject) {
      return inputObject instanceof CreativeDocumentModel;
    }
  }, {
    key: "getFrameRangeForMask",
    value: function getFrameRangeForMask(documentModel, maskId) {
      if (!CreativeDocumentModel.isCreativeDocumentModel(documentModel)) {
        throw new Error('documentModel should be of type CreativeDocumentModel');
      }

      if ((0, _isEmptyString["default"])(maskId)) {
        throw new Error('maskId is invalid');
      }

      var masks = documentModel.masks;
      if (!masks.has(maskId)) return null;
      var mask = masks.get(maskId);
      return new _FrameRange["default"](mask.frameStart, mask.frameEnd);
    }
  }, {
    key: "getFrameRangeForRootMask",
    value: function getFrameRangeForRootMask(documentModel) {
      return CreativeDocumentModel.getFrameRangeForMask(documentModel, _creative.ROOT_MASK_KEY);
    }
  }]);
  return CreativeDocumentModel;
}(_WireObject2["default"]);

exports["default"] = CreativeDocumentModel;